/**
 * Einheitliche Texte für paginierte Listen (fix 100 pro Seite).
 */

export function formatListPageSummary({
  loading = false,
  total = 0,
  page = 1,
  pages = 1,
  searchActive = false,
  suffix = "",
} = {}) {
  if (loading) return "Lade Daten…";

  const tot = Math.max(0, Number(total) || 0);
  const p = Math.max(1, Number(page) || 1);
  const pg = Math.max(1, Number(pages) || 1);
  const searchHint = searchActive ? " (gefiltert)" : "";
  const base = `${tot.toLocaleString("de-CH")} Einträge${searchHint}`;
  const pageHint = pg > 1 ? ` · Seite ${p} von ${pg}` : "";
  const extra = suffix ? ` · ${suffix}` : "";

  return `${base}${pageHint}${extra}`;
}
